import WishListButton from '@lt/components/components/WishListButton';
import { useTranslation } from '@lt/localization';
import React from 'react';
import { NBSP } from 'src/constants/common';
import PackageId from 'src/routes/Checkout/components/PackageId';
import { vibrate } from 'src/utils/commonUtils';
import styled from 'styled-components';
import type { Props as PropsFromParentComponent, PropsFromRedux } from '.';

type StyledComponentsProps = {
  className?: string;
};

const Wishlist = (
  props: PropsFromRedux & StyledComponentsProps & PropsFromParentComponent,
) => {
  const {
    addToWishlist,
    removeFromWishlist,
    isContainedInWishlist,
    wishlistIdentifier,
    type,
    price,
    wishlistItemId,
    isCheckoutPage,
    isHotelPage,
    isMobile,
    className,
    isWhiteHeart,
    isHotelCardFromMap,
    requestId,
    isMobileHotelPage,
  } = props;
  const { t } = useTranslation();
  const onRemove = () => {
    removeFromWishlist(wishlistItemId || 0);
  };
  const onAdd = () => {
    addToWishlist({
      wishlistIdentifier,
      type,
      price,
      requestId,
      isFromMap: isHotelCardFromMap,
    });
  };
  const onClick = isContainedInWishlist ? onRemove : onAdd;
  const handleWishlistClicked = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    onClick();
    /**
     * Вибрация устройства при добавлении и удалении
     */
    vibrate(200);
  };

  return (
    <>
      {!isCheckoutPage && !isHotelPage && (
        <StyledSearchWishlistButton
          isSelected={isContainedInWishlist}
          onClick={handleWishlistClicked}
          className={className}
          isHotelCard={isWhiteHeart}
          isMobile={isMobile}
          $isMobileHotelPage={isMobileHotelPage}
        />
      )}

      {isCheckoutPage && (
        <CheckoutButton onClick={onClick} className={className}>
          <PackageId />
          <CheckoutWishlistIcon
            isSelected={isContainedInWishlist}
            onClick={handleWishlistClicked}
            isMobile={isMobile}
          />
        </CheckoutButton>
      )}
      {isHotelPage && (
        <HotelButton
          isActive={isContainedInWishlist}
          onClick={onClick}
          className={className}
        >
          <WishListButton
            isMobile={isMobile}
            isSelected={isContainedInWishlist}
            onClick={handleWishlistClicked}
          />
          {isContainedInWishlist ? (
            <span>{t('hotel.wishlist.active', { nbsp: `${NBSP}` })}</span>
          ) : (
            <span>{t('hotel.wishlist.passive', { nbsp: `${NBSP}` })}</span>
          )}
        </HotelButton>
      )}
    </>
  );
};

const StyledSearchWishlistButton = styled(WishListButton)<{
  isMobile: boolean;
  $isMobileHotelPage?: boolean;
}>`
  width: 24px;
  height: 24px;
  z-index: 1;

  ${(props) => props.$isMobileHotelPage && `right: 8px;`}

  ${(props) => props.isMobile && `position: absolute;`}
`;

const HotelButton = styled.button.attrs({ type: 'button' })<{
  isActive: boolean;
}>`
  margin-top: 5px;
  margin-left: auto;
  display: flex;
  width: 90px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  white-space: pre-line;
  color: #919499;
  border: 0;
  cursor: pointer;

  svg {
    stroke: #919499;
    margin-bottom: 5px;
  }

  ${({ isActive }) =>
    isActive &&
    `
    color: #17181a;

    svg {
      stroke: unset;
    }
  `};

  &:hover {
    color: #17181a;

    svg {
      stroke: #d0021b;
    }
  }
`;

const CheckoutButton = styled.button.attrs({ type: 'button' })`
  margin-left: auto;
  padding: 0 17px;
  display: flex;
  min-width: 150px;
  height: 45px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  background: #fff;
  border: none;
  border-radius: 45px;
  cursor: pointer;

  &:hover svg {
    stroke: #d0021b;
  }
`;

const CheckoutWishlistIcon = styled(WishListButton)`
  margin-left: 10px;
`;

export default Wishlist;
